import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const ScheduledMaintenanceOutageBanner = () => import(/* webpackChunkName: "4-feat-scheduled-maintenance-outage-banner" */ './ScheduledMaintenanceOutageBanner');

export default lazyLoadOnRender({ loader: ScheduledMaintenanceOutageBanner });